import React from "react";
import { useService } from "../hooks/useService";
import StorageService from "../../services/StorageService";

export function getAdminRolePermissions() {   
  /**
   * @type {StorageService}
   */
  const storage = useService(StorageService);
  const user = storage.get("local::user", {});
  return user?.adminRole?.permissions || [];
}

export function getPermissionByServiceName(serviceName) {
  const permissions = getAdminRolePermissions();
  return permissions.find(
    (perm) => perm.organisationServiceName === serviceName
  );
}

export function isServiceVisible(serviceName) {
  const permission = getPermissionByServiceName(serviceName);
  if (permission === undefined) return true;
  return permission.isVisible;
}

export function isServiceEditable(serviceName) {
  if (!isServiceVisible(serviceName)) return false;
  const permission = getPermissionByServiceName(serviceName);
  if (permission === undefined) return true;
  return permission.isEditable;
}
